module.exports = __webpack_public_path__ + "img/audio_classify4_3.04b25556.png";